import * as PIXI from 'pixi.js';
import type { WordElementMetrics } from './WordElementMetrics';

/**
 * A placeholder for word elements.
 *
 * Placeholders are necessary when measuring e.g. line width. With highlights, the line bounds is just the bounds of
 * the contained highlights. But we want the actual line bounds measuring all of the text, and including placeholders
 * forces the bounds to the actual width of the line.
 */
export class WordElementPlaceholder extends PIXI.Graphics {
    metrics: WordElementMetrics;
    text: string;

    constructor(wordElementMetrics: WordElementMetrics) {
        super();

        this.metrics = wordElementMetrics;
        this.text = wordElementMetrics.text;

        const bounds = wordElementMetrics.getBounds();
        this.drawRect(0, 0, bounds.width, bounds.height);
        this.alpha = 0;
    }
}
